import { create } from 'zustand';

export enum CandidateListTab {
  CANDIDATES = 'candidates',
  TALENT_LISTS = 'talent-lists'
}

type CandidateListStore = {
  activeTab: CandidateListTab;
  totalCandidatesCount: number | null;
  talentListsCount: number | null;
  integrationProvider: string;
  isCandidatesCountLoading: boolean;
  setActiveTab: (tab: CandidateListTab) => void;
  setTotalCandidatesCount: (count: number | null) => void;
  setTalentListsCount: (count: number | null) => void;
  setIntegrationProvider: (provider: string) => void;
  setIsCandidatesCountLoading: (isLoading: boolean) => void;
};

export const useCandidateListStore = create<CandidateListStore>()((set) => ({
  activeTab: CandidateListTab.CANDIDATES,
  totalCandidatesCount: null,
  talentListsCount: null,
  integrationProvider: 'ATS',
  isCandidatesCountLoading: false,
  setActiveTab: (activeTab) => set({ activeTab }),
  setTotalCandidatesCount: (totalCandidatesCount) =>
    set({ totalCandidatesCount }),
  setTalentListsCount: (talentListsCount) => set({ talentListsCount }),
  setIntegrationProvider: (integrationProvider) => set({ integrationProvider }),
  setIsCandidatesCountLoading: (isCandidatesCountLoading) =>
    set({ isCandidatesCountLoading })
}));
